import countries from "i18n-iso-countries";

import en from "i18n-iso-countries/langs/en.json";
import nl from "i18n-iso-countries/langs/nl.json";
import es from "i18n-iso-countries/langs/es.json";
import ca from "i18n-iso-countries/langs/ca.json";

countries.registerLocale(en);
countries.registerLocale(nl);
countries.registerLocale(es);
countries.registerLocale(ca);

const SUPPORTED_COUNTRY_LANGUAGES = ["en", "nl", "es", "ca"];

export function normalizeLanguage(language) {
  const normalized = String(language || "en")
    .trim()
    .toLowerCase()
    .split("-")[0];

  return SUPPORTED_COUNTRY_LANGUAGES.includes(normalized) ? normalized : "en";
}

export function getCountryOptions(language = "en") {
  const locale = normalizeLanguage(language);

  const names = countries.getNames(locale, {
    select: "official",
  });

  return Object.entries(names)
    .map(([code, name]) => ({
      value: code,
      code,
      label: name,
    }))
    .sort((first, second) =>
      first.label.localeCompare(second.label, locale, {
        sensitivity: "base",
      }),
    );
}

export function getCountryName(countryCode, language = "en") {
  if (!countryCode) {
    return "";
  }

  const locale = normalizeLanguage(language);

  const code = String(countryCode).trim().toUpperCase();

  return (
    countries.getName(code, locale, {
      select: "official",
    }) ||
    countries.getName(code, "en", {
      select: "official",
    }) ||
    code
  );
}

export function isValidCountryCode(countryCode) {
  if (!countryCode) {
    return false;
  }

  return countries.isValid(String(countryCode).trim().toUpperCase());
}

export function normalizeCountryCode(countryCode) {
  if (!countryCode) {
    return "";
  }

  const value = String(countryCode).trim().toUpperCase();

  if (!countries.isValid(value)) {
    return "";
  }

  return countries.toAlpha2(value) || value;
}

export function getCountryByCode(countryCode, language = "en") {
  const code = normalizeCountryCode(countryCode);

  if (!code) {
    return null;
  }

  return {
    value: code,
    code,
    label: getCountryName(code, language),
  };
}

export { countries };
